import { initPlatforms } from "./platforms/init";
import { handleReport } from "./platforms/report";
import { AnalyticsMessageEvent, SetAnalyticsDataEvent } from "./types";

const messageChannel = new MessageChannel();

let interval: number;

const onSetAnalyticsData = async ({ data }: SetAnalyticsDataEvent) => {
  await initPlatforms(data);

  window.parent?.postMessage('postInitPlatform', window.parent.location.origin);
}

const onPong = () => {
  window.parent?.postMessage('init', window.parent.location.origin);
  clearInterval(interval)
}

const handlers = {
  "setAnalyticsData": onSetAnalyticsData,
  "report": handleReport,
  "pong": onPong
}

const onMessage = (e: MessageEvent<AnalyticsMessageEvent>) => {
  if (typeof e.data.action !== "string") return;

  const handler = handlers[e.data.action];

  if (!handler) {
    return;
  }

  handler(e.data);
}

messageChannel.port1.onmessage = onMessage;

// ping top window until it initializes
// because iframe might load faster than parent
// in that case parent won't receive port of iframe
interval = window.setInterval(() => {
  window.parent?.postMessage('ping', window.parent.location.origin);
}, 1000);

window.addEventListener('message', (e) => {
  if (e.data === 'pong') {
    window.parent?.postMessage('init', window.parent.location.origin, [messageChannel.port2]);
    clearInterval(interval);
  }

  if (e.data === 'pong-no-init') {
    clearInterval(interval);
  }
})

window.handlers = handlers;
